var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "20px",
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.138157209 8.66666667 29.1232662 8.66666667 29.1232662 0.0481962963 0.138157209 0.0481962963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "10.6646423 16.02055 10.6646423 0.159827778 0.183133537 0.159827778 0.183133537 16.02055 10.6646423 16.02055"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Splash-screen",
    transform: "translate(-53.000000, -533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(53.000000, 533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icEmail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.547157, 10.417526)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6339946,2.94141852 L10.87776,0.0481962963 L0.138157209,8.1496037 C0.528553918,8.4681037 1.05546636,8.66671481 1.63682096,8.66671481 L27.6311683,8.66671481 C28.2103343,8.66671481 28.7350581,8.4681037 29.1232662,8.1496037 L18.3902293,0.0481962963 L14.6339946,2.94141852 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.676962,0.517183333 C29.2865653,0.196516667 28.7618414,7.22222222e-05 28.1782982,7.22222222e-05 L2.18395087,7.22222222e-05 C1.6047849,7.22222222e-05 1.08006108,0.198442593 0.689664375,0.521035185 L15.1811245,11.4504241 L29.676962,0.517183333 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "0 1.6756037 0 17.5307889 10.4816181 9.69275185"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(19.697662, 1.510119)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "0.183133537 8.1827537 10.6647517 16.02055 10.6647517 0.159827778"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/icEmail.48698c953e6a917daf12270a415c3fe6.svg";
export { ForwardRef as ReactComponent };